import { default as _91_46_46_46slug_93r5CSHo5OzaMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/[...slug].vue?macro=true";
import { default as _4049wsMp0fKqWMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/404.vue?macro=true";
import { default as indexuCVxY6yZTGMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedanktR8UJkM5zz2Meta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_93ollOBosLktMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/contact/[slug].vue?macro=true";
import { default as index0TY1EbstbuMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/contact/index.vue?macro=true";
import { default as indexx17fyt6fX3Meta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93kMccosOzwrMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexhYlt0YGktFMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieNCoq3yGVRlMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_933sIukODOAuMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93Jum6BTr94mMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexIPKj3szT0TMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93dcuznmbtZdMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_932HaiXhK87BMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93oYhvyHTPshMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93Qu55U0XWlaMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as indexOEhXKrgEC7Meta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenkOwUbBbjOQMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_93Fu0L7H2cP0Meta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedanktzyglRf0HvqMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faqXst74mOCiEMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningosWnxILVkoMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijzeCF0kn3lVYvMeta } from "/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93r5CSHo5OzaMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexuCVxY6yZTGMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedanktR8UJkM5zz2Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_93ollOBosLktMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: index0TY1EbstbuMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexx17fyt6fX3Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93kMccosOzwrMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexhYlt0YGktFMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieNCoq3yGVRlMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_933sIukODOAuMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexIPKj3szT0TMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93dcuznmbtZdMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_932HaiXhK87BMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93oYhvyHTPshMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93Qu55U0XWlaMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: indexOEhXKrgEC7Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenkOwUbBbjOQMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_93Fu0L7H2cP0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faqXst74mOCiEMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/17/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]